import React, { useMemo } from "react";
import UserGearIconSVG from "assets/svg/user-gear-icon";
import GraduationCapIconSVG from "assets/svg/graduation-cap-icon";
import ChatUserIconSVG from "assets/svg/chat-user-icon";
import BriefCaseExperienceIconSVG from "assets/svg/brief-case-icon";
import Favicon from "components/fav-icon/Favicon";
import AwardsIconSVG from "assets/svg/awards-icon";
import FileUserRepresentationIconSVG from "assets/svg/file-user-icon";

import _ from "lodash";
import { socialTemplate } from "utils/constant";
import { useResume } from "redux/modules/resume/hooks";
import { truncateBioForTemplate } from "utils/bio-limit";
import { TEMPLATE_NAME_1 } from "constants/options";

export default function TemplateOneFullPageOne({
  details = {},
  social = [],
  primaryColor,
  secondaryColor,
  tertiaryColor,
}) {
  const { bio } = useResume();
  const truncatedBio = truncateBioForTemplate(bio, TEMPLATE_NAME_1);
  // const socMed = useMemo(() => {
  //   let arrays = Object.entries(social);
  //   return arrays.map((obj) => {
  //     let key = obj[0];
  //     let value = obj[1];
  //     return { key, value };
  //   });
  // }, [social]);
  return (
    <div className="w-full">
      <div style={{ minHeight: "1123px" }} className="h-full overflow-hidden">
        {/** ================ bio ================ */}
        {details?.bio && details.hasOwnProperty("bio") && (
          <div className="flex flex-col space-x-2 mb-8">
            <div
              className="px-2 py-1.5 rounded-sm mb-4"
              style={{ backgroundColor: secondaryColor }}>
              <p className="text-sm font-bold text-resumeTempFourTextPrimary tracking-resumeOne">
                Bio
              </p>
            </div>
            <div
              className="pr-2 text-4xs text-darkerGray tracking-resume leading-4.5"
              dangerouslySetInnerHTML={{ __html: truncatedBio ?? "" }}
            />
          </div>
        )}
        {/** ================ professional ================ */}
        {(details?.skills || (details && details.hasOwnProperty("occupations") &&
          !_.isEmpty(details?.occupations)) ||
          details?.education ||
          details?.training ||
          details?.experience) && (
          <div className="flex flex-col space-x-2 mb-8">
            <div
              className="px-2 py-1.5 rounded-sm mb-4"
              style={{ backgroundColor: secondaryColor }}>
              <p className="text-sm font-bold text-resumeTempFourTextPrimary tracking-resumeOne">
                Professional Information
              </p>
            </div>
            <div className="grid gap-y-4 pr-2">
              {/* ========== Abilities / Skills / Specialties  ======== */}
              {details && details.hasOwnProperty("skills") && details.skills && (
                  <div className="flex flex-row space-x-2">
                    <UserGearIconSVG className="w-5.5 h-5.5" fill={primaryColor} />
                    <div style={{ width: "calc(100% - 24px)" }}>
                      <p className="text-sm text-resumeTempFourTextPrimary font-semibold tracking-resumeOne">
                        Abilities / Skills / Specialties
                      </p>
                      <div className="w-full mt-1">
                        <p className="text-4xs text-darkerGray tracking-resume leading-4.5 line-clamp-7">
                          {details.skills}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              {/* ========== Education ======== */}
              {details && details.hasOwnProperty("education") && details.education && (
                <div className="w-full flex flex-row space-x-2">
                  <GraduationCapIconSVG
                    className="w-5.5 h-5.5"
                    fill={primaryColor}
                  />
                  <div style={{ width: "calc(100% - 24px)" }}>
                    <p className="text-sm text-resumeTempFourTextPrimary font-semibold tracking-resumeOne">
                      Education
                    </p>
                    <div className="w-full mt-1">
                      <p className="text-4xs text-darkerGray tracking-resume leading-4.5 line-clamp-7">
                        {details.education}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {/* ========== Education ======== */}
              {details && details.hasOwnProperty("training") && details.training && (
                <div className="w-full flex flex-row space-x-2">
                  <ChatUserIconSVG className="w-5.5 h-5.5" fill={primaryColor} />
                  <div style={{ width: "calc(100% - 24px)" }}>
                    <p className="text-sm text-resumeTempFourTextPrimary font-semibold tracking-resumeOne">
                      Training
                    </p>
                    <div className="w-full mt-1">
                      <p className="text-4xs text-darkerGray tracking-resume leading-4.5 line-clamp-7">
                        {details.training}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {/* ========== Experience ======== */}
              {details && details.hasOwnProperty("experience") && details.experience && (
                <div className="w-full flex flex-row space-x-2">
                  <BriefCaseExperienceIconSVG
                    className="w-5.5 h-5.5"
                    fill={primaryColor}
                  />
                  <div style={{ width: "calc(100% - 24px)" }}>
                    <p className="text-sm text-resumeTempFourTextPrimary font-semibold tracking-resumeOne">
                      Experience
                    </p>
                    <div className="w-full mt-1">
                      <p className="text-4xs text-darkerGray tracking-resume leading-4.5 line-clamp-7">
                        {details.experience}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {details && details.hasOwnProperty("awards") && details?.awards?.trim() &&
                details.awards && (
                  <div className="w-full flex flex-row space-x-2">
                    <AwardsIconSVG
                      className="w-5.5 h-5.5"
                      fill={primaryColor}
                    />
                    <div style={{ width: "calc(100% - 24px)" }}>
                      <p className="text-sm text-resumeTempFourTextPrimary font-semibold tracking-resumeOne">
                        Awards
                      </p>
                      <div className="w-full mt-1">
                        <p className="text-4xs text-darkerGray tracking-resume leading-4.5 line-clamp-7">
                          {details.awards}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {details && details.hasOwnProperty("representation") && details?.representation?.trim() &&
                details.representation && (
                  <div className="w-full flex flex-row space-x-2">
                    <FileUserRepresentationIconSVG
                      className="w-5.5 h-5.5"
                      fill={primaryColor}
                    />
                    <div style={{ width: "calc(100% - 24px)" }}>
                      <p className="text-sm text-resumeTempFourTextPrimary font-semibold tracking-resumeOne">
                        Representation
                      </p>
                      <div className="w-full mt-1">
                        <p className="text-4xs text-darkerGray tracking-resume leading-4.5 line-clamp-7">
                          {details.representation}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        )}
        {/** social links */}
        {!_.isEmpty(social) && (
          <div className="flex flex-col space-x-2 mb-8">
            <div
              className="px-2 py-1.5 rounded-sm"
              style={{ backgroundColor: secondaryColor }}>
              <p className="text-sm font-bold text-resumeTempFourTextPrimary tracking-resumeOne">
                Follow Me
              </p>
            </div>
            <div className="flex justify-center flex-wrap">
              {Array.isArray(social) && (social || []).map((obj, index) => {
                  return (
                    <div
                      className="flex flex-row items-center break-all space-x-2 space-y-2 my-2"
                      key={index}>
                      <Favicon domain={obj.value} hasFavIconFile={obj.icon} width="w-[22px]"/>
                      <div className="leading-1">
                        {/* <span className="text-6xs text-resumeTempFourTextPrimary">
                          {obj.value}
                        </span> */}
                      </div>
                    </div>
                  );
              })}
            </div>
          </div>
        )}
      </div>
      {/* ========== footer ======== */}
      <div
        className="w-full h-8 border-t px-2"
        style={{ borderColor: "#DAE4EF" }}>
        <div className="w-full h-full flex flex-row justify-between items-center">
          <p className="font-medium text-6xs text-darkerGray">Page 1</p>
          <div className="flex flex-start gap-1.5">
            <button className="w-2 h-2 rounded-full bg-primary" />
            <button className="w-2 h-2 rounded-full bg-pageInactive" />
          </div>
        </div>
      </div>
    </div>
  );
}
